import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { firebaseConnect } from "react-redux-firebase";
import { NavLink, withRouter } from "react-router-dom";
import "firebase/auth";
import "../../App.css";
import { logIn } from "../../store/actions/authActions";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      totpCode: "",
      formError: [],
      user: null,
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleFormSubmit = async (e) => {
    e.preventDefault();
    if (this.handleValidation()) {
      try {
        const { email, password } = this.state;
        await this.props.firebase
          .auth()
          .signInWithEmailAndPassword(email, password);
      } catch (error) {
        console.error(error.code);
        if (
          error.code === "auth/wrong-password" ||
          error.code === "auth/user-not-found"
        ) {
          this.setState({
            formError: ["Utilisateur inconnu ou mot de passe incorrect"],
          });
        } else {
          this.setState({ formError: [error.message] });
        }
      }
    }
  };

  handleValidation = () => {
    let valid = true;
    let message = [];

    if (this.state.email === "") {
      valid = false;
      message.push("Veuillez saisir une adresse mail");
    }

    if (this.state.password === "") {
      valid = false;
      message.push("Veuillez saisir un mot de passe");
    }

    this.setState({
      formError: message,
    });

    return valid;
  };

  renderFormAlert = () => {
    const { formError } = this.state;

    return formError.length > 0 ? (
      <div
        className="alert alert-danger"
        role="alert"
        style={{ flexDirection: "column" }}
      >
        {formError.map((error, index) => (
          <div
            className="alert-text"
            key={index}
            style={{ alignSelf: "flex-start" }}
          >
            {error}
          </div>
        ))}
      </div>
    ) : null;
  };

  handleRedirect = () => {
    const { location } = this.props;
    if (location.state) {
      if (location.state.prevPath && location.state.prevPath !== "/login") {
        window.location.href = location.state.prevPath;
      } else {
        window.location.href = "/";
      }
    } else {
      window.location.href = "/";
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.fbAuth.uid) {
      this.handleRedirect();
    }
  }

  componentDidMount() {
    if (this.props.fbAuth.uid) {
      this.handleRedirect();
    }
  }

  render() {
    const { authError, isFetching, fbAuth } = this.props;
    const buttonText = isFetching === true ? "En cours..." : "Se connecter";

    if (!fbAuth.isLoaded) return "";

    return (
      <div className="position-relative overflow-hidden auth-bg min-vh-100 w-100 d-flex align-items-center justify-content-center">
        <div className="d-flex align-items-center justify-content-center w-100">
          <div className="row justify-content-center w-100 my-5 my-xl-0">
            <div className="col-md-9 d-flex flex-column justify-content-center">
              <div className="card mb-0 bg-body auth-login m-auto w-100">
                <div className="row gx-0">
                  <div className="col-xl-6 border-end">
                    <div className="row justify-content-center py-4">
                      <div className="col-lg-11">
                        <div className="card-body">
                          <a
                            href="https://zeplan.ai/"
                            className="text-nowrap logo-img d-block mb-4 w-100"
                          >
                            <img
                              src="https://zeplan.ai/wp-content/uploads/2024/04/Document-size-Black.png"
                              className="dark-logo"
                              alt="Logo-Dark"
                              style={{ width: "150px" }}
                            />
                          </a>
                          <h2 className="lh-base mb-4">
                            Connectez vous à ZEPLAN
                          </h2>
                          <form onSubmit={this.handleFormSubmit}>
                            {authError ? (
                              <div
                                className="alert alert-danger alert-dismissible"
                                role="alert"
                              >
                                <div className="alert-text">
                                  {authError} Essayez à nouveau.
                                </div>
                                <div className="alert-close">
                                  <i
                                    className="flaticon2-cross kt-icon-sm"
                                    data-dismiss="alert"
                                  ></i>
                                </div>
                              </div>
                            ) : null}

                            {this.renderFormAlert()}

                            <div className="mb-3">
                              <label htmlFor="email" className="form-label">
                                Adresse Email
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Email"
                                name="email"
                                autoComplete="off"
                                onChange={this.handleChange}
                                style={{ background: "rgb(109, 98, 141, 12%)" }}
                              />
                            </div>

                            <div className="">
                              <label htmlFor="password" className="form-label">
                                Mot de Passe
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                placeholder="Mot de passe"
                                name="password"
                                onChange={this.handleChange}
                                style={{ background: "rgb(109, 98, 141, 12%)" }}
                              />
                            </div>
                            <div className="d-flex align-items-center mb-4 mt-1">
                              <p className="fs-12 mb-0 mt-0 fw-medium">
                                <NavLink
                                  className="text-primary fw-semibold ms-2"
                                  to="/forgotten-password"
                                >
                                  Mot de passe oublié
                                </NavLink>
                              </p>
                            </div>

                            <div className="d-flex align-items-center justify-content-between mb-4">
                              <div className="form-check">
                                <input
                                  className="form-check-input primary"
                                  type="checkbox"
                                  value=""
                                  id="flexCheckChecked"
                                  checked
                                />
                                <label
                                  className="form-check-label text-dark"
                                  htmlFor="flexCheckChecked"
                                >
                                  Se souvenir de moi
                                </label>
                              </div>
                            </div>

                            <button
                              type="submit"
                              className="btn btn-dark w-100 py-8 mb-4 rounded-1"
                              disabled={isFetching}
                            >
                              {buttonText}
                            </button>

                            <div className="d-flex align-items-center">
                              <p className="fs-12 mb-0 fw-medium">
                                Pas encore de compte ?
                              </p>
                              <NavLink
                                className="text-primary fw-semibold ms-2"
                                to="/register"
                              >
                                S'incrire maintenant
                              </NavLink>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 d-none d-xl-block">
                    <div className="row justify-content-center align-items-start h-100">
                      <div className="col-lg-9">
                        <div
                          id="auth-login"
                          className="carousel slide auth-carousel mt-5 pt-4"
                          data-bs-ride="carousel"
                          data-bs-interval="5000"
                        >
                          <div className="carousel-indicators">
                            <button
                              type="button"
                              data-bs-target="#auth-login"
                              data-bs-slide-to="0"
                              className="active"
                              aria-current="true"
                              aria-label="Slide 1"
                            ></button>
                            <button
                              type="button"
                              data-bs-target="#auth-login"
                              data-bs-slide-to="1"
                              aria-label="Slide 2"
                            ></button>
                            <button
                              type="button"
                              data-bs-target="#auth-login"
                              data-bs-slide-to="2"
                              aria-label="Slide 3"
                            ></button>
                          </div>
                          <div className="carousel-inner">
                            <div className="carousel-item active">
                              <div className="d-flex align-items-center justify-content-center w-100 h-100 flex-column gap-9 text-center">
                                <img
                                  src="https://zeplan.ai/wp-content/uploads/2024/04/Document-size-Black.png"
                                  alt="login-side-img"
                                  width="300"
                                  className="img-fluid"
                                />
                                <h4 className="mb-0">Optimisez votre temps</h4>
                                <p className="fs-12 mb-0">
                                  Zeplan est votre outil ultime pour optimiser
                                  la gestion des courses VTC. Gagnez en
                                  efficacité grâce à nos graphiques avancés et à
                                  notre interface intuitive.
                                </p>
                                <a
                                  href="javascript:void(0)"
                                  className="btn btn-primary rounded-1"
                                >
                                  En savoir plus
                                </a>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="d-flex align-items-center justify-content-center w-100 h-100 flex-column gap-9 text-center">
                                <img
                                  src="https://zeplan.ai/wp-content/uploads/2024/04/Document-size-Black.png"
                                  alt="login-side-img"
                                  width="300"
                                  className="img-fluid"
                                />
                                <h4 className="mb-0">
                                  Gestion de nombreuses données
                                </h4>
                                <p className="fs-12 mb-0">
                                  Optimisez votre flotte de VTC avec Zeplan.
                                  Visualisez les données critiques et prenez des
                                  décisions éclairées pour maximiser la
                                  satisfaction des clients.
                                </p>
                                <a
                                  href="javascript:void(0)"
                                  className="btn btn-primary rounded-1"
                                >
                                  En savoir plus
                                </a>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="d-flex align-items-center justify-content-center w-100 h-100 flex-column gap-9 text-center">
                                <img
                                  src="https://zeplan.ai/wp-content/uploads/2024/04/Document-size-Black.png"
                                  alt="login-side-img"
                                  width="300"
                                  className="img-fluid"
                                />
                                <h4 className="mb-0">Un outil connecté</h4>
                                <p className="fs-12 mb-0">
                                  Zeplan simplifie la gestion de votre service
                                  de VTC. Suivez les performances en temps réel
                                  et optimisez vos ressources pour une
                                  rentabilité accrue.
                                </p>
                                <a
                                  href="javascript:void(0)"
                                  className="btn btn-primary rounded-1"
                                >
                                  En savoir plus
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    fbAuth: state.firebase.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logIn: (credentials) => dispatch(logIn(credentials)),
  };
};

export default compose(
  withRouter,
  firebaseConnect(),
  connect(mapStateToProps, mapDispatchToProps)
)(Login);
